<template>
  <BaseForm
    ref="baseForm"
    :title="$t('models.auth.changeEmail')"
    :data-object="requestEmailChange"
    :content-type="'user'"
    :custom-submit="true"
    :on-custom-submit="changeEmail"
    :column-width="'is-6 is-offset-2'"
  >
    <template #content>
      <v-text-field
        v-model.trim="requestEmailChange.email1"
        prepend-inner-icon="mdi-email-outline"
        :label="$t('models.auth.newEmail')"
        type="email"
        name="email1"
        :rules="[rules.required]"
      >
      </v-text-field>
      <v-text-field
        v-model.trim="requestEmailChange.email2"
        prepend-inner-icon="mdi-email-outline"
        :label="$t('models.auth.newEmailRepeat')"
        type="email"
        name="email2"
        :rules="[rules.required]"
      >
      </v-text-field>
    </template>
  </BaseForm>
  <LoadingOverlay v-model:loading="overlay" />
</template>

<script setup lang="ts">
import { onMounted, Ref, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { apiClient } from '@/api/ApiClient'
import BaseForm from '@/components/common/BaseForm.vue'
import LoadingOverlay from '@/components/common/LoadingOverlay.vue'
import { RequestEmailUpdate } from '@/models/core/models'
const router = useRouter()
const store = useStore()

type RequestChangeEmailProps = {
  id: string
}

const rules = {
  required: (value) => !!value || 'Feld muss ausgefüllt sein',
}

const props = defineProps<RequestChangeEmailProps>()
const overlay = ref(false)

const requestEmailChange: Ref<RequestEmailUpdate> = ref({
  email1: '',
  email2: '',
})
const baseForm: Ref<typeof BaseForm> = ref(null)

onMounted(() => {
  if (props.id !== store.state.global.profileId) {
    router.push({ name: 'profile-list' })
  }
})

function changeEmail() {
  overlay.value = true
  apiClient
    .requestUpdateEmail(props.id, requestEmailChange.value)
    .then((response) => {
      overlay.value = false
      router.push({
        name: 'verify_change_email',
        params: {
          id: props.id,
          email: requestEmailChange.value.email2,
          nonce: response.data.nonce,
        },
      })
    })
    .catch((error) => {
      overlay.value = false
      baseForm.value.handleError(error)
    })
}
</script>

<style></style>
